.media-minimal-skin .media-controls {
  --media-popover-side-offset: calc(var(--media-spacing) * (var(--media-base-side-offset, 2) + 1));
  --media-tooltip-side-offset: var(--media-popover-side-offset);
  --media-popover-boundary-offset: calc(var(--media-spacing) * (var(--media-base-boundary-offset, 0) + 1));
  --media-tooltip-boundary-offset: var(--media-popover-boundary-offset);

  display: flex;
  align-items: center;
  padding: calc(var(--media-spacing) * 1);
  container: media-controls / inline-size;
  text-shadow: 0 1px 0 var(--media-shadow-current-color);
  background-color: var(--media-controls-background-color);
  backdrop-filter: var(--media-controls-backdrop-filter);

  &:dir(rtl) {
    flex-direction: row-reverse;
  }
}
